import { render, staticRenderFns } from "./SigningConfirmModal.vue?vue&type=template&id=166b0cda"
import script from "./SigningConfirmModal.vue?vue&type=script&lang=js"
export * from "./SigningConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./SigningConfirmModal.vue?vue&type=style&index=0&id=166b0cda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports